module.exports = __webpack_public_path__ + "media/images/icon_list/share_icon_facebook-eb1f01a464a9a86b264f68848e1ee15c.svg";